<template>
    <div class="invite">
        <div class="head">
            <i v-if="!isWx" class="goBack" @click="goBack"></i>
            <div class="tab">
                <div @click="checkTab(0)" :class="{active: tabIndex === 0}">邀请<span :class="{line: tabIndex === 0}"></span></div>
                <div @click="checkTab(1)" :class="{active: tabIndex === 1}">推荐<span :class="{line: tabIndex === 1}"></span></div>
            </div>
        </div>
        <!-- 邀请 -->
        <div class="listBox" v-show="tabIndex === 0">
            <van-list
                v-model="loading"
                :finished="finished"
                finished-text="没有更多了"
                @load="initInviteList"
            >
                <van-cell v-for="item in inviteList" :key="item.id">
                    <a :href="item.redirect_url" class="item">
                        <div class="intro">
                            <p class="van-multi-ellipsis--l2">{{ item.title }}</p>
                            <span>{{item.answer_num > 0 ? item.answer_num+"回答" : "暂无回答"}}&nbsp;{{item.loves > 0 ? item.loves+"点赞" : ""}}</span>
                        </div>
                        <van-image 
                            lazy-load
                            fit="cover"
                            :width="120"
                            :height="80"
                            :src="item.resources.length > 0 ?item.resources[0].cut_image:''"
                        />
                    </a>
                </van-cell>
            </van-list>
        </div>
        <!-- 推荐 -->
        <div class="listBox" v-show="tabIndex === 1">
            <van-list
                v-model="loading2"
                :finished="finished2"
                finished-text="没有更多了"
                @load="initcommandList"
            >
                <van-cell v-for="item in commandList" :key="item.id">
                    <a :href="item.redirect_url" class="item">
                        <div class="intro">
                            <p class="van-multi-ellipsis--l2">{{ item.title }}</p>
                            <span>{{item.answer_num > 0 ? item.answer_num+"回答" : "暂无回答"}}&nbsp;{{item.loves > 0 ? item.loves+"点赞" : ""}}</span>
                        </div>
                        <van-image 
                            lazy-load
                            fit="cover"
                            :width="120"
                            :height="80"
                            :src="item.resources.length > 0 ?item.resources[0].cut_image:''"
                        />
                    </a>
                </van-cell>
            </van-list>
        </div>
    </div>
</template>

<script>
import { getIndexList } from '@/request/api'
import { checkWx } from '@/pages/index/custom'

export default {
    data() {
        return {
            tabIndex: 0,
            // 邀请列表
            inviteList: [],
            loading: false, // 加载中
            finished: false, // 加载完毕
            invitePage: 1,
            // 推荐列表
            commandList: [],
            loading2: false, // 加载中
            finished2: false, // 加载完毕
            commandPage: 1,
            isWx: true
        }
    },
    methods: {
        // 选项卡切换
        checkTab(index) {
            this.tabIndex = index;
            if(index === 1 ) {
                this.commandList = [];
                this.commandPage = 1;
                this.initcommandList()
            }
        },
        goBack() {
            this.$router.go(-1);
        },
        // 获取邀请列表
        initInviteList() {
            getIndexList({
                page: this.invitePage,
                pcount: 8,
                type: 3,
            }).then( res => {
                let {list, error_code} = res;
                if(error_code === 0) {
                    if (list.length === 0 || !list) {
                        this.finished = true;
                        return false;
                    }
                    list.map(item => this.inviteList.push(item));
                    this.invitePage++;
                    this.loading = false;
                }
            }).catch( error => {
                console.log(error)
            })
        },
        // 获取推荐列表
        initcommandList() {
            getIndexList({
                page: this.commandPage,
                pcount: 8,
                type: 1,
            }).then( res => {
                let {list, error_code} = res;
                if(error_code === 0) {
                    if (list.length === 0 || !list) {
                        this.finished2 = true;
                        return false;
                    }
                    list.map(item => this.commandList.push(item));
                    this.commandPage++;
                    this.loading2 = false;
                }
            }).catch( error => {
                console.log(error)
            })
        },
    },
    created() {
        this.isWx = checkWx();
    }
}
</script>

<style lang="less" scoped>
.listBox {
    box-sizing: border-box;
    padding-top: 3.75rem;
    .item {
        display: flex;
        align-items: center;
        box-sizing: border-box;
        padding: 1.25rem;
        .intro {
            flex: 1;
            padding-right: 1rem;
            height: 5rem;
            display: flex;
            flex-direction: column;
            justify-content: space-between;
            p {
                font-size:18px;
                font-weight:500;
                color:rgba(34,34,34,1);
            }
            span {
                display: block;
                font-size:12px;
                font-weight:400;
                color:rgba(167,167,167,1);
                margin-top: .625rem;
            }
        }
        .van-image {
            border-radius: 4px;
            overflow: hidden;
        }
    }
}
.head {
    position: fixed;
    width: 100%;
    height: 3.75rem;
    top: 0;
    left: 0;
    background-color: #fff;
    z-index: 4000;
    .goBack {
        position: absolute;
        top: 50%;
        transform: translateY(-50%);
        left: 1.25rem;
        width: 1.5rem;
        height: 1.5rem;
        background: url(../../../../../assets/img/icon_back.png);
        background-size: 100% 100%;
    }
}
.tab {  
    position: absolute;
    left: 50%;
    transform: translateX(-50%);
    height: 3.75rem;
    line-height: 3.75rem;
    box-sizing: border-box;
    display: flex;
    justify-content: center;
    div {
        position: relative;
        margin: 0 .75rem;
        font-size:16px;
        font-weight:400;
        color:rgba(34,34,34,1);
        height: 100%;
        line-height: 3.75rem;
        transition: all .3s;
        list-style: none;
        &.active{
            font-size:24px;
            font-weight:600;
        }
    }
    .line {
        position: absolute;
        bottom: 8px;
        left: 50%;
        margin-left: -10px;
        width: 1.25rem;
        height: .25rem;
        background-color: #FF4C67;
        box-shadow: 0px 2px 6px 0px #fd7c90;
        border-radius: 10px;
    }
}
</style>